(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.actions = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ADD_FEATURE_FLAGS = exports.ADD_FEATURE_FLAGS = '@@feature-flags/ADD_FEATURE_FLAG';

  var addFeatureFlagsSuccess = function addFeatureFlagsSuccess(features) {
    return {
      type: ADD_FEATURE_FLAGS,
      features: features
    };
  };

  var addFeatureFlags = exports.addFeatureFlags = function addFeatureFlags(features) {
    return function (dispatch) {
      dispatch(addFeatureFlagsSuccess(features));
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-feature-flags/dist/actions.js
// module id = ./node_modules/react-redux-feature-flags/dist/actions.js
// module chunks = 0 1